import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "@/firebase/config";

const MAX_FILE_SIZE_MB = 5;

/**
 * StorageService — única porta de entrada para upload de arquivos ao
 * Firebase Storage (fotos de perfil, banners/logos de grupo mais adiante).
 */
export const StorageService = {
  async uploadUserPhoto(uid: string, file: File | Blob): Promise<string> {
    validateImage(file);
    const path = `users/${uid}/avatar-${Date.now()}.${getExtension(file)}`;
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file, { contentType: file.type });
    return getDownloadURL(storageRef);
  },
};

function validateImage(file: File | Blob) {
  if (!file.type.startsWith("image/")) {
    throw new Error("O arquivo precisa ser uma imagem.");
  }
  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    throw new Error(`A imagem deve ter no máximo ${MAX_FILE_SIZE_MB}MB.`);
  }
}

function getExtension(file: File | Blob): string {
  if ("name" in file) return file.name.split(".").pop()?.toLowerCase() ?? "jpg";
  // Blob gerado pelo recorte (PhotoCropDialog) não tem `name` — deriva a
  // extensão do contentType (sempre "image/jpeg" nesse caso, ver
  // PhotoCropDialog.handleCrop).
  return file.type.split("/").pop()?.toLowerCase() ?? "jpg";
}
